<app-subnav [items]="SUBNAV_SETTNGS" ></app-subnav>
<div class="container">
    <h1 class="w-100 text-center">Statistiken</h1>

    <div class="mx-auto d-flex flex-wrap justify-content-between align-items-start">
        <table class="table table-striped w-auto d-inline-block">
            <tr><th colspan="2" class="text-center">    Aktionen                                </th></tr>
            <tr><td> Gesamt             </td><td class="value"> {{stats.anzahl_aktionen.gesamt}}              </td></tr>
            <tr><td> Aktiv              </td><td class="value"> {{stats.anzahl_aktionen.aktiv}}               </td></tr>
            <tr><td> Inaktiv            </td><td class="value"> {{stats.anzahl_aktionen.inaktiv}}             </td></tr>
            <tr><td> Plätze frei        </td><td class="value"> {{stats.anzahl_aktionen.platze_frei}}         </td></tr>
            <tr><td> Voll               </td><td class="value"> {{stats.anzahl_aktionen.voll}}                </td></tr>
            <tr><td> 90% Ausgelastet    </td><td class="value"> {{stats.anzahl_aktionen.belegt_90}}           </td></tr>
            <tr><td> 50% Ausgelastet    </td><td class="value"> {{stats.anzahl_aktionen.belegt_50}}           </td></tr>
            <tr><td> Mit Warteliste     </td><td class="value"> {{stats.anzahl_aktionen.warteliste}}          </td></tr>
        </table>
        <table class="table w-auto d-inline-block">
            <tr><th colspan="2" class="text-center">    Kinder                                  </th></tr>
            <tr><td> Gesamt             </td><td class="value"> {{stats.anzahl_kinder.gesamt}}                </td></tr>
            <tr><td> Soziallpass        </td><td class="value"> {{stats.anzahl_kinder.sozialpass}}            </td></tr>
            <tr><td> Nur Voranmeldung   </td><td class="value"> {{stats.anzahl_kinder.nur_voranmeldungen}}    </td></tr>
            <tr><td> Mit Anmeldung      </td><td class="value"> {{stats.anzahl_kinder.mit_anmeldungen}}       </td></tr>
            <tr><td> Mit Buchungen      </td><td class="value"> {{stats.anzahl_kinder.mit_gebucht}}           </td></tr>
            <tr><td> Mit Warteliste     </td><td class="value"> {{stats.anzahl_kinder.mit_warteliste}}        </td></tr>
            <tr><td> Ohne Anmeldungen   </td><td class="value"> {{stats.anzahl_kinder.ohne_anmeldungen}}      </td></tr>
        </table>
        <table class="table table-striped w-auto d-inline-block">
            <tr><th colspan="2" class="text-center">    Eltern                                  </th></tr>
            <tr><td> Gesamt             </td><td class="value"> {{stats.anzahl_eltern}}                       </td></tr>
        </table>
        <table class="table w-auto d-inline-block">
            <tr><th colspan="2" class="text-center">    Plätze                                  </th></tr>
            <tr><td> Gesamt             </td><td class="value"> {{stats.anzahl_platze.gesamt}}                </td></tr>
            <tr><td> Voranmeldung       </td><td class="value"> {{stats.anzahl_platze.voranmeldung}}          </td></tr>
            <tr><td> Anmeldung          </td><td class="value"> {{stats.anzahl_platze.anmeldung}}             </td></tr>
            <tr><td> Warteliste         </td><td class="value"> {{stats.anzahl_platze.warteliste}}            </td></tr>
            <tr><td> Gebucht            </td><td class="value"> {{stats.anzahl_platze.gebucht}}               </td></tr>
            <tr><td> Abgemeldet         </td><td class="value"> {{stats.anzahl_platze.abgemeldet}}            </td></tr>
        </table>
        <table class="table w-auto d-inline-block">
            <tr><th colspan="2" class="text-center">    Geld                                    </th></tr>
            <tr><td> Rechnung           </td><td class="value"> {{stats.geld.rechnungen}} €                   </td></tr>
            <tr><td> Bezahlt            </td><td class="value"> {{stats.geld.bezahlt}} €                      </td></tr>
            <tr><td> Offen              </td><td class="value"> {{stats.geld.rechnungen - stats.geld.bezahlt}} € </td></tr>
        </table>
    </div>


    <table class="table w-auto mt-3 mx-auto">
        <tr>
            <th>Alter (Jahre)</th>
            <th *ngFor="let c of stats.anzahl_kinder.alter" class="text-center">{{c.age}}</th>
        </tr>
        <tr>
            <th>Anzahl (Kinder)</th>
            <td *ngFor="let c of stats.anzahl_kinder.alter" class="text-center">
                <span *ngIf="c.count !== 0">
                    {{c.count}}
                </span>
            </td>
        </tr>
    </table>
</div>